export default from './LoginPage';



// WEBPACK FOOTER //
// ./src/pages/login/index.js